<template>

  <div>
    <!-- GOOGLE SINGLE SIGN ON MODAL FOR MISSING DATA -->
    <!-- 
      if you want manually open modal window
      <button class="btn btn-dark" @click="openModal" data-target="#loginModal">Login</button> 
    -->
    <div class="modal" ref="modal" id="loginModal" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{$t('pages.register.ssoMissingData')}}</h5>
          </div>
          <div class="modal-body">
            <form role="form" @submit.prevent="registerUser"> 
              <div class="form-group">
                <label for="username">{{$t('pages.register.username')}}</label>
                <input :value="username" @input="updateRegisterUsername" type="text" class="form-control" placeholder="" required>
                <span v-if="usernameInputErr" class="text-danger mb-20">{{$t('pages.register.ssoMissingDataEmpty')}}</span>
                <br/>
                <label for="studentId">{{$t('pages.register.studentId')}}</label>
                <input :value="studentId" @input="updateRegisterStudentId" type="text" class="form-control" placeholder="" required>
                <span v-if="studentIdInputErr" class="text-danger">{{$t('pages.register.ssoMissingDataEmpty')}}</span>
                <span v-if="studentIdInputRgxErr" class="text-danger">{{$t('pages.register.ssoMissingDataStudentIdInvalid')}}</span>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col-xs-6" style="text-align: left;">
                <button type="submit" class="btn btn-success" @click="setUsernameAndStudentId">
                  {{$t('pages.register.ssoMissingDataSubmit')}}
                </button> 
              </div>
              <div class="col-xs-6" style="text-align: right;">
                <button type="submit" class="btn btn-secondary" @click="logout" data-dismiss="modal">
                  {{ $t('pages.userIconInHeader.signOut') }}
                </button>
              </div>
            </div>              
          </div>
        </div>
      </div>
    </div>

    <!-- tvoje skupine -->
    <div class="box box-default color-palette-box">
      <div class="box-header with-border">
        <h3 class="box-title"> {{ $t("pages.group.welcomeMessage2") }}</h3>
        <button v-if="jeAdmin" type="button" class="btn btn-success pull-right" @click.prevent="colapseCreateGroup(1)"><i class="fa fa-plus" style="color: white"></i> {{$t('pages.adminpanel.group.createPrompt')}}</button>
      </div>
      <div v-if="!colCG" class="small-box-footer">
        <br>
        <creategroup></creategroup>
      </div>
      <div class="small-box info-box containter-full" v-for="(group, jIndeks) in groupList.myGroups" v-bind:key="jIndeks" v-if="jeAdmin || group.public"
           :class="[group.groupColor !== null ? group.groupColor : defaultGColor, detectMobile() ? 'left-align' : '', group.isPending ? '' : 'group-box']">
        <group-template :group="group" :jIndeks="jIndeks" :showYear="true" :groupListLength="groupList.archived.length + groupList.myGroups.length + groupList.otherGroups.length" :hideProgress="true"></group-template>
        <editgroup v-if="group.showEdit" :group="group"></editgroup>
        <edityear :year="group" v-if="group.showEditYear"></edityear>
        <createyear :year="group" v-if="group.showCreateYear"></createyear>
      </div>
      <!-- END New version -->
      <!-- /.box-body -->
    </div>

     <!-- ostale skupine -->
    <div class="box box-default color-palette-box" v-if="groupList.otherGroups && groupList.otherGroups.length > 0">
      <div class="box-header with-border">
        <h3 class="box-title"> {{ $t("pages.group.welcomeMessage") }}</h3>
      </div>
      <div class="small-box info-box containter-full" v-for="(group, jIndeks) in groupList.otherGroups" v-bind:key="jIndeks" v-if="jeAdmin || group.public" :class="[group.groupColor !== null ? group.groupColor : defaultGColor, detectMobile() ? 'left-align' : '', jeAdmin ? 'group-box' : '']">
        <group-template :group="group" :jIndeks="jIndeks + groupList.myGroups.length" :showYear="true" :groupListLength="groupList.archived.length + groupList.myGroups.length + groupList.otherGroups.length" :hideProgress="true"></group-template>
        <editgroup v-if="group.showEdit" :group="group"></editgroup>
        <edityear :year="group" v-if="group.showEditYear"></edityear>
        <createyear :year="group" v-if="group.showCreateYear"></createyear>
      </div>
      <!-- END New version -->
      <!-- /.box-body -->
    </div>

    <!--Arhivirane skupine-->
    <div class="box box-default color-palette-box" v-if="jeAdmin && groupList.archived && groupList.archived.length > 0">
      <div class="box-header with-border">
        <h3 class="box-title"> {{ $t("pages.group.welcomeMessage3") }}</h3>
      </div>
      <div class="small-box info-box containter-full" v-for="(group, jIndeks) in groupList.archived" v-bind:key="jIndeks" v-if="jeAdmin || group.public" :class="[group.groupColor !== null ? group.groupColor : defaultGColor, detectMobile() ? 'left-align' : '', jeAdmin ? 'group-box' : '']">
        <group-template :group="group" :showYear="true" :jIndeks="jIndeks + groupList.myGroups.length + groupList.otherGroups.length" :groupListLength="groupList.archived.length + groupList.myGroups.length + groupList.otherGroups.length" :hideProgress="true"></group-template>
        <editgroup v-if="group.showEdit" :group="group"></editgroup>
        <edityear :year="group" v-if="group.showEditYear"></edityear>
        <createyear :year="group" v-if="group.showCreateYear"></createyear>
      </div>
    </div>

    <!--modal za zahtevana polja-->
    <div class="modal modal-primary fade" id="modal-edit-required-fields">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 class="modal-title">{{$t('pages.requiredField.enterPrompt')}}</h4>
          </div>
          <div class="modal-body">
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('firstName')" class="form-group">
              <label>{{$t('pages.requiredField.firstName')}}</label>
              <input v-model="currUser['firstName']" type="text" class="form-control">
            </div>
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('lastName')" class="form-group">
              <label>{{$t('pages.requiredField.lastName')}}</label>
              <input v-model="currUser['lastName']" type="text" class="form-control">
            </div>
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('studentId')" class="form-group">
              <label>{{$t('pages.requiredField.studentId')}}</label>
              <input v-model="currUser['studentId']" type="text" class="form-control">
            </div>
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('allowUseOfMyResults')" class="form-check">
              <input v-model="currUser['allowUseOfMyResults']" type="checkbox" id="allowUseOfResults" class="form-check-input">
              <label class="form-check-label" for="allowUseOfResults">{{$t('pages.requiredField.allowUseOfMyResults')}}</label>
            </div>
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('username')" class="form-group">
              <label>{{$t('pages.requiredField.username')}}</label>
              <input v-model="currUser['username']" type="text" class="form-control">
            </div>
            <div v-if="selectedGroup.requiredFields != null && selectedGroup.requiredFields.includes('profilePictureUrl')" class="form-group">
              <label>{{$t('pages.requiredField.profilePictureUrl')}}</label>
              <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="goToProfile()">{{$t('pages.buttons.goToUserProfile')}}</button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal">{{$t('pages.adminpanel.tablets.modalApproveNo')}}</button>
            <button type="button" class="btn btn-outline" data-dismiss="modal" @click.prevent="submitChangesJoinYear(selectedGroup)">{{$t('pages.adminpanel.tablets.modalDeleteYes')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>

</template>

<script>
import Rest from './../../services/rest'
import creategroup from './../admin/CreateGroup'
import router from '@/router/router'
import editgroup from './../admin/EditGroup'
import { mapState, mapGetters } from 'vuex'
import grouptemplate from '@/components/groups/GroupTemplate.vue'
import edityear from './../admin/EditYear'
import createyear from './../admin/CreateYear'
import $ from 'jquery'

export default {
  name: 'groupList',
  data () {
    return {
      isShow: true,
      usernameInputErr: false,
      studentIdInputErr: false,
      studentIdInputRgxErr: false
    }
  },
  created () {
    this.$store.dispatch('getGroupsNew')
    this.$store.commit('updateSelectedGroupId', null)
  },
  mounted () {
    if (!this.jeAdmin) {
      this.$store.dispatch('checkIfUsernameAndStudentIdAreSet', this.currUser)
      .then(() => {
        this.openModal()
      })
      .catch(() => {})
    }
  },
  computed: {
    ...mapState({
      groupList: state => state.groupList,
      selectedGroup: state => state.selectedGroup,
      currUser: state => state.userData,
      defaultGColor: state => state.defaultGColor,
      colCG: state => state.adminpanel.colapseCreateGroup,
      username: state => state.register.username,
      studentId: state => state.register.studentId
    }),
    ...mapGetters({
      jeAdmin: 'hasAdminRole'
    })
  },
  methods: {
    openModal () {
      $('#loginModal').modal('show')
    },
    setUsernameAndStudentId () {
      // validate modal user data input
      this.usernameInputErr = !this.username
      this.studentIdInputErr = !this.studentId
      var studentIdInputRegexPattern = /\b[0-9]{8}$\b/
      if (!studentIdInputRegexPattern.test(this.studentId)) {
        this.studentIdInputRgxErr = true
      } else {
        this.studentIdInputRgxErr = false
      }

      if (!this.usernameInputErr && !this.studentIdInputErr && !this.studentIdInputRgxErr) {
        // update user with missing data
        var userMissingData = {
          username: this.username,
          studentId: this.studentId
        }
        this.$store.dispatch('setUsernameAndStudentId', userMissingData)
        .then(() => {
          $('#loginModal').modal('hide')
        })
        .catch(() => {})
      }
    },
    detectMobile () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    goToGroup (group) {
      // router.push('/group/' + groupId + '/' + yearId)
      let latest = group.yearId
      this.$store.commit('updateSelectedGroup', group)
      this.$store.commit('updateSelectedYear', latest)
      this.$store.commit('updateSelectedGroupId', group.groupId)
      router.push({name: 'exercises', params: {gid: group.groupId, yid: group.yearId, sid: 'root'}})
    },
    goToProfile () {
      router.push({name: 'profile'})
    },
    listExercises (groupId, yearId) {
      // router.push('/group/' + groupId + '/' + yearId)
      this.$store.commit('updateSelectedGroupId', groupId)
      router.push({name: 'exercises', params: {gid: groupId, yid: yearId, sid: 'root'}})
    },
    // isNotMember (groupa) {
    //   for (let i = 0; i < groupa.years.length; i++) {
    //     if (groupa.years[i].id === groupa.latestYearId) return !groupa.years[i].isEnrolled
    //   }
    // },
    disEnroll (group) {
      // CONTSTRAINT if user can be enrolled to max one group
      let enrollmentId = group.enrollmentId
      Rest.request('DELETE', `/enrollment/${enrollmentId}`).then(() => {
        this.$set(group, 'isEnrolled', false)
      }).catch((err) => {
        console.log(err)
      })
    },
    editGroup (group) {
      this.closeAllDropdowns(this.groupList.length)
      this.$store.dispatch('getGroup', {
        gid: group.groupId,
        yid: group.yearId,
        sid: 'root'
      }).then(() => {
        this.$set(group, 'showEdit', !group.showEdit)
      })
    },
    submitChangesJoinYear (grupa) {
      // window.jQuery('#modal-edit-required-fields').modal('toggle')
      let tren = this
      let postdata = {}
      for (let requiredField of grupa.requiredFields) {
        if (tren.currUser[requiredField] == null) continue
        postdata[requiredField] = tren.currUser[requiredField]
      }
      Rest.request('PUT', '/users/me', postdata).then(() => {
      })
      this.joinYear(grupa)
    },
    joinYear (grupa) {
      let tren = this
      let fn = async () => { // async wrapper
        try {
          if (grupa.requiredFields !== null) {
            let potrebenVpis = false
            for (let requiredField of grupa.requiredFields) {
              if (tren.currUser[requiredField] == null) {
                potrebenVpis = true
              }
              // if (tren.currUser[requiredField] != null) continue
              // let promptArray = (prompt(this.$t('pages.requiredField.enterPrompt') + ' ' + this.$t('pages.requiredField.' + requiredField) + ':'))
              // if (promptArray) {
              //   let postdata = {}
              //   // postdata[requiredField] = promptArray
              //   this.$set(postdata, requiredField, promptArray)
              //   this.$set(tren.currUser, requiredField, promptArray)
              //   await Rest.request('PUT', '/users/me', postdata).then(() => {
              //   })
              // } else {
              //   throw new Error('user canceled prompt')
              // }
            }
            if (potrebenVpis) {
              this.$store.commit('updateSelectedGroup', grupa)
              window.jQuery('#modal-edit-required-fields').modal('toggle')
              return
            }
          }
          let postdata = {
            yearId: grupa.yearId
          }
          await Rest.request('POST', '/enrollment', postdata).then(() => {
            this.$set(grupa, 'isEnrolled', true)
            this.$store.dispatch('getGroupsNew')
          })
        } catch (error) {
          console.log(error)
        }
      }
      fn()
    },
    getYears (yearId) {
      window.jQuery('.dropdown-toggle').dropdown()
    },
    ChoseYear (group, yearId) {
      group.latestYearId = yearId
    },
    toggleDropdown () {
      window.jQuery('.dropdown-toggle').dropdown()
    },
    colapseCreateGroup (meSelf) {
      this.$store.commit('toggleCreateGroup')
    },
    logout () {
      this.$store.dispatch('logout')
    },
    updateRegisterUsername (e) {
      this.$store.commit('updateRegisterUsername', e.target.value)
    },
    updateRegisterStudentId (e) {
      this.$store.commit('updateRegisterStudentId', e.target.value)
    }
  },
  components: {
    editgroup: editgroup,
    edityear: edityear,
    createyear: createyear,
    'group-template': grouptemplate,
    creategroup: creategroup
  }
}
</script>
<style scoped>
.container-full {
  margin: 0 auto;
  width: 100%;
}
.col-centered{
    float: none;
    margin: 0 auto;
}
.product {
    margin: 0 auto;
}
.desno {
    float: right;
}
.textBeautify {
    font-size: medium;
}
.btn-group-vertical > button{
    margin-bottom:20px;
    border-radius:10px !important;
}
#imePoskupine {
  font-size: large;
  font-weight: bold;
}

.progress-with-margin {
  margin-right: 90px !important;
}
.fa-cog, .caret {
  color: black;
}
.fa-plus, .fa-cog {
  margin-right: 1ex;
}
.group-box {
  cursor: pointer;
}
.dropdownMenuButton {
  background-color:white;
}
@media only screen and (max-width: 767px) {
    .progress-with-margin {
      margin-right: 0px !important;
    }
}
.fa-plus {
  color: black;
}

.small-title {
  font-size: 25px;
}
.small-margin-text {
  margin-top: 0px;
  margin-bottom: 0px;
}
.no-padding-box {
  padding: 0px;
  padding-left: 0px;
  min-height: 70px;
}
.left-align{
  text-align: left;
  min-height: auto;
}

.modal-header {
  background-color: #00A65A; 
  color: white;
}
</style>



// WEBPACK FOOTER //
// GroupList.vue?4a97b4ff